import { helpers } from "vuelidate/lib/validators";

export const phoneValidator =  helpers.regex(
  "phoneValidator",
  /^(\(?\+?[0-9]*\)?)?[0-9_\- \(\)\.]*$/m
);